import PortUtils from "../portlibs/PortUtils";
import { TableCellProps } from "@mui/material";
import { OpenHistory } from "../dialogs/History";
import Holding from "../models/Holding";
import GTable from "../libs/gtable/GTable";
import useCashSummary from "../portlibs/useCashSummary";
import AssetChart from "../components/AssetChart";

const COLS = ["type", "ca", "us", "us_ca", "total"]

type TAssetTypes = "CASH"|"SAVE"|"GIC"|"BOND"|"EQUITY"|"DEPOSITS"|"GAINS"|"GAINS%"|"TOTAL"

const LABELS : Record<string,string> = {
    type:"ASSET",
    ca:"CA",
    us:"US",
    us_ca:"US (C$)",
    total:"TOTAL"
}

type TCashRow = {type:TAssetTypes, ca:number, us:number, us_ca:number, total:number}
function makeRow(type:TAssetTypes, ca:number, us:number, exchange:number) : TCashRow {
    return {type, ca, us, us_ca:us*exchange, total:ca + us*exchange}
}

export default function Home(){
    const  { cash_ca_holding, cash_us_holding, cash_ca, cash_us, save_ca, save_us, bond_ca, bond_us, gic_ca, gic_us, equity_ca, equity_us, 
        deposit_ca, deposit_us, total_ca, total_us, usd2cad} = useCashSummary()

    const showHistory = OpenHistory()
    const onCash = (holding:Holding) => () => showHistory(holding)

    const cell = (row:TCashRow, col:string) => {
        if (col=="type") return row.type
        else if (row.type=="GAINS%") return (row as any)[col].toFixed(3)+"%"
        else return PortUtils.formatCurrency(col=="USD" ? 1 : 0, (row as any)[col], false)
    }
    const cellProps = (row:TCashRow, col:string) : TableCellProps => {
        const ret : TableCellProps = {}
        if (row.type=="TOTAL") ret.className="w700i"
        else if ((row.type=="GAINS" || row.type=="GAINS%") && col!="ASSET") {
            ret.className = (row as any)[col]<0 ? "red" : "green"
        }

        if (col!="type") {
            ret.align = "right"
            if (row.type=="CASH") {
                if (col=="ca") ret.onClick = onCash(cash_ca_holding)
                else if (col=="us") ret.onClick = onCash(cash_us_holding)
            }
        }        
        return ret
    }
    const headerProps = (col:string) : TableCellProps => {
        return {align:col=="type" ? "left" : "right"}
    }
    const footerCellProps = (row:TCashRow, col:string) : TableCellProps => {
        const ret = cellProps(row, col);
        if (row.type=="DEPOSITS") ret.className = "blue"
        return ret
    }
    const label = (col:string) => LABELS[col] || col

    const rows = [makeRow("CASH", cash_ca, cash_us, usd2cad), makeRow("SAVE", save_ca, save_us, usd2cad), makeRow("GIC", gic_ca, gic_us, usd2cad), makeRow("BOND", bond_ca, bond_us, usd2cad), makeRow("EQUITY", equity_ca, equity_us, usd2cad)]
    const footers = [makeRow("DEPOSITS", deposit_ca, deposit_us, usd2cad), makeRow("TOTAL", total_ca, total_us, usd2cad)]
    return <GTable classNames={{home:true}} tableName="home" disableSort={true} cols={COLS} rows={rows} 
        bodyCell={cell} label={label} bodyCellProps={cellProps} headerCellProps={headerProps} 
        sorter={() => () => 0} footers={footers} footerCellProps={footerCellProps}>
        <AssetChart/>
    </GTable>
}